// Ladiosa's full menu. Prices intentionally minimal/curated per category
// (problem statement only specified $29 for the signature meal).

export const SIGNATURE_DEAL = {
  title: "The $29 Meal",
  tagline: "Champagne, Sliders & Truffle Fries",
  description:
    "Our house signature — three smash sliders on brioche, a flute of crisp champagne, and a paper bucket of black truffle fries. Designed for two, devoured by one.",
  price: "29",
};

export const MENU = [
  {
    id: "appetizers",
    name: "Appetizers, Brunch & Breakfast",
    subtitle: "Day-starters & shared plates",
    items: [
      { name: "Fried Ravioli with Vodka Sauce" },
      { name: "French Onion Soup Twice-Baked Potato" },
      { name: "Longevity Taco" },
      { name: "Grilled Apricot, Honey & Petit Basque Bites" },
      { name: "Pan Con Tomate & Garlic Confit" },
      { name: "Egg Yolk Confit" },
      { name: "Steamed Eggs" },
      { name: "Rum & Amaretto Peaches" },
      { name: "Jammy Egg Ceviche" },
      { name: "Strawberry Brûlée" },
      { name: "Spicy Tuna Crispy Rice Balls" },
      { name: "Tamari Cured & Confit Yolks Over Crispy Rice" },
      { name: "Crab Rangoon Taquitos" },
      { name: "Whipped Brie & Honey Butter Toast" },
      { name: "Salsa Macha Honey Cured Yolks" },
      { name: "Misoyaki Steak Frites Skewers" },
      { name: "Honey Butter Chicken Biscuit" },
      { name: "Croque Madame Croissant" },
      { name: "Berry Croissant Bake" },
      { name: "Strawberry Brie Croissant Waffles" },
      { name: "Bacon Gouda Croissant" },
      { name: "Bacon, Egg & Cheese Puff Pastry" },
      { name: "Burrata Focaccia Sandwich" },
      { name: "Japanese Crispy Egg Sandwich" },
      { name: "Flat Stomach Salad" },
      { name: "Marinated Feta" },
      { name: "Bacon, Egg & Cheese Sandwich" },
      { name: "Koulouri Filled with Smashed Avocado" },
      { name: "Brie Upside-Down Bites" },
      { name: "Crispy Chilli Oil Egg Toast" },
      { name: "Veggie Gouda Omelet" },
      { name: "Crispy Bang Bang Shrimp Tacos" },
      { name: "Gut-Loving Bircher Muesli" },
      { name: "Tomato Tart" },
      { name: "Steak, Egg & Cheese Croissant" },
      { name: "Courgette Tart" },
      { name: "Asian-Style Napa Cabbage Rolls" },
      { name: "Soupy Blanket Dumplings" },
      { name: "Mediterranean Summer Eggplant Platter" },
    ],
  },
  {
    id: "meals",
    name: "Meals & Dinner",
    subtitle: "Home-style mains, soul to Mediterranean",
    items: [
      { name: "The $29 Meal", note: "Champagne, Sliders & Truffle Fries", price: "29" },
      { name: "Meat Pockets" },
      { name: "Short Rib Lasagna" },
      { name: "Smoked Salmon Potato" },
      { name: "One-Pan Tandoori Chicken & Rice with Mint Sauce" },
      { name: "Monkfish au Poivre" },
      { name: "Coq au Riesling with Rice" },
      { name: "Sage & Onion Chicken Balls" },
      { name: "Jerk Fish & Chips" },
      { name: "Spicy Salsa Macha Breakfast Tacos" },
      { name: "Chicken Roll" },
      { name: "Shrimp & Crab Puff Pastries" },
      { name: "The Angelina Club Sandwich" },
      { name: "Butterfly Chicken Drumsticks" },
      { name: "Eggs, Sauté Potatoes & Tarragon Sausages" },
      { name: "Marry Me Chicken Lasagna" },
      { name: "Marry Me Chicken with Hasselback Potatoes & Broccolini" },
      { name: "Garlic & Herb Chicken with Rice" },
      { name: "Creamy Marry Me Chicken" },
      { name: "Butter Caramelised Bananas & Dates" },
      { name: "Salmon & Potatoes with Caper-Dill Chimichurri" },
      { name: "Leeks au Gratin & Poached Egg" },
      { name: "Norwegian Red King Crab Legs & Gochujang Coconut Butter" },
      { name: "Fennel Arugula Salad" },
      { name: "Eggplant, Mortadella & Mozzarella Skewers" },
      { name: "Chinese Steamed Eggs & Cured Yolks" },
      { name: "Hasselback Potatoes" },
      { name: "Heavy Cream Eggs" },
      { name: "Garlic Egg Yolk Confit" },
      { name: "Broccoli Rice with Garlic-Butter Chicken" },
      { name: "Mediterranean Olive Oil Bread Dip" },
      { name: "Chicken Zucchini Meatballs with Cucumber-Avocado Salad" },
      { name: "Whipped Brie & Fig Mosaic Baguette" },
      { name: "Garlic Bread, Whipped Brown Butter" },
      { name: "Dover Sole with Fennel" },
      { name: "Peruvian-Style Chicken with Coconut Rice & Grilled Corn" },
      { name: "Griyo Bao Tacos — Haiti meets Asia" },
      { name: "Shrimp Milanese" },
      { name: "Miso Maple Short Ribs" },
      { name: "Thit Bo Xao Sa — Stir-Fried Lemongrass Beef" },
      { name: "Tahini Cream Salad with Sardines, Sumac & Black Sesame" },
      { name: "Coconut Curry Chicken Meatballs with Charred Cabbage" },
      { name: "Pickle Chicken Wrap with Dilly Ranch" },
      { name: "Nuoc Cham Chicken" },
      { name: "A Very Good Spring Chicken" },
      { name: "Kongnamul Bulgogi" },
      { name: "Spicy Miso Ramen" },
      { name: "Fried White Fish with Creamy White Wine Sauce & Lemon Prawns" },
      { name: "Sun Chicken Skewers, Skin-On Fries, Corn, Slaw & Spicy Mayo" },
      { name: "Tomato & Ricotta Tart with Basil Oil" },
      { name: "Steak Sourdough — Basil Chimichurri, Whipped Ricotta, Heirloom Tomato" },
      { name: "Savory Breakfast Waffles" },
    ],
  },
  {
    id: "wings",
    name: "Wings",
    subtitle: "Brined, baked, broken down by region",
    items: [
      { name: "Smokey Creole" },
      { name: "Caribbean Baked Lemon-Pepper Butterfly Drumsticks" },
      { name: "Firecracker Butterfly Drumsticks (Jamaican Style)" },
      { name: "Cilantro Lime Chicken Wings" },
      { name: "Zesty Crispy Chicken" },
      { name: "Turkish Tender Baked Wings" },
    ],
  },
  {
    id: "soups",
    name: "Soups",
    subtitle: "Slow-simmered, ladle to bowl",
    items: [
      { name: "Cajun White Chicken Chili" },
      { name: "Chicken Orzo Soup" },
      { name: "Remy's Potato & Leek Soup" },
      { name: "Marry Me Chicken Meatball Soup" },
      { name: "Vichyssoise" },
      { name: "Ginseng Chicken Soup" },
      { name: "Lotus Root Pork Rib Soup" },
      { name: "Creamy Mushroom Coconut Soup" },
    ],
  },
  {
    id: "salads",
    name: "Salads",
    subtitle: "Crisp, charred, considered",
    items: [
      { name: "Greek Chicken Slaw" },
      { name: "Crispy Chicken Caesar Schnitzel" },
      { name: "Burrata, Peach & Cherry Salad" },
      { name: "Spring Vegetables — Fire & Char, Beet Intensity" },
      { name: "Asparagus Orzo Salad" },
      { name: "Smashed Cucumber Salad" },
      { name: "Crispy Roasted Quinoa & Asparagus Salad" },
      { name: "Roasted Broccoli Salad" },
      { name: "Sweet Potato Salad with Crispy Parmesan-Artichoke Crumble" },
      { name: "Caprese Caesar Chicken" },
      { name: "Greek-Style Chicken Salad" },
      { name: "Crispy Chicken Caesar Pasta Salad" },
      { name: "Crispy Potato & Asparagus Salad" },
      { name: "Gut & Glow Crunch Salad" },
      { name: "High Protein Mediterranean Cucumber Salad" },
      { name: "Warm Potato Salad" },
      { name: "Dilly Carrot, Lentil & Feta Salad" },
      { name: "Crunchy Roasted Broccoli with Creamy Garlic-Miso Dressing" },
    ],
  },
  {
    id: "sides",
    name: "Sides",
    subtitle: "The small things, done loudly",
    items: [
      { name: "French Onion Baked Potatoes" },
      { name: "Creamy Scalloped Potatoes" },
      { name: "Oven-Baked Crispy Italian Potatoes" },
      { name: "Greek Lemon Potatoes" },
      { name: "Corn Fritters" },
      { name: "Crispy Eggplant Sandwiches with Mozzarella & Tomato" },
      { name: "Mediterranean Roasted Carrots" },
      { name: "Braised Cabbage with Crispy Lentils" },
      { name: "Crispy Lemon-Feta Roasted Potatoes" },
      { name: "Crispy Parm-Crusted Smashed Potatoes" },
      { name: "Street Corn Skewers" },
      { name: "Japanese Long Fries" },
      { name: "Shaken Potatoes" },
      { name: "High-Fiber Purple Rice" },
      { name: "Melting Leeks" },
      { name: "Ultra Creamy Garlic Mashed Potatoes" },
      { name: "Roasted Caramelized Cabbage, Caper-Garlic Crunch, Honey-Dijon" },
    ],
  },
  {
    id: "pastas",
    name: "Pastas",
    subtitle: "Hand-tossed, lemon-bright, herb-heavy",
    items: [
      { name: "Garlic Butter Steak Bites & Alfredo Pasta" },
      { name: "Angel Tomato Pasta" },
      { name: "Zangy Green Goat Pasta" },
      { name: "Ladiosa's Pesto Pasta Salad" },
      { name: "Herby Lemon Shrimp Pasta" },
      { name: "Floppy Lemony Pasta" },
      { name: "So-What, No-Ziti, Now? — Baked Ziti" },
    ],
  },
  {
    id: "sandwiches",
    name: "Sandwiches & Wraps",
    subtitle: "Bread, butter, ambition",
    items: [
      { name: "Turkey Bacon Ranch Melt" },
      { name: "Chicken Caesar Baked Wraps" },
      { name: "Pickle Chicken Sandy" },
      { name: "Classic Tuna Melt" },
    ],
  },
  {
    id: "sauces",
    name: "Sauces & Dips",
    subtitle: "House-made, ladled on request",
    items: [
      { name: "Chimichurri Ranch" },
      { name: "Caesar" },
      { name: "Honey Mustard" },
      { name: "Balsamic" },
      { name: "Lemon Garlic" },
      { name: "Avocado Lime" },
      { name: "Tahini" },
      { name: "Tzatziki" },
      { name: "Asian Sesame" },
      { name: "Crispy Onion & Herb Dip" },
      { name: "Crab Rangoon Dip" },
      { name: "Whipped Feta & Pistachio Dip" },
      { name: "Green Goddess with Cottage Cheese" },
    ],
  },
  {
    id: "drinks",
    name: "Drinks",
    subtitle: "Cold-pressed, house-mixed",
    items: [
      { name: "Peach Blueberry Lemonade" },
      { name: "Mango Passion Fruit Lemonade" },
      { name: "Beet Lemonade" },
      { name: "Still & Sparkling Water" },
    ],
  },
  {
    id: "kids",
    name: "For the Little Ones",
    subtitle: "Small portions, big love",
    items: [
      { name: "Kid's Chicken Sandwich" },
    ],
  },
  {
    id: "dessert",
    name: "Dessert",
    subtitle: "Sweet endings",
    items: [
      { name: "Blueberry, Lemon & Mascarpone Muffin Cupcakes" },
      { name: "Chocolate & Dulce de Leche Candle" },
    ],
  },
];

export const BRUNCH_HIGHLIGHTS = [
  {
    name: "Caramelised Banana Waffle",
    description: "Chantilly cream, salted caramel sauce.",
  },
  {
    name: "Buttermilk Pancakes",
    description: "Mixed berries, berry purée and Greek yoghurt.",
  },
  {
    name: "Croque Monsieur",
    description: "Pomme frites and a dressed mixed-leaf salad.",
  },
  {
    name: "Grilled Lobster",
    description: "Garlic butter, chips, lemon.",
  },
  {
    name: "Lobster Macaroni Cheese",
    description: "House cavatappi, three-cheese mornay, butter crumb.",
  },
  {
    name: "Eggs Benedict",
    description: "House muffin, hollandaise, peppered ham or smoked salmon.",
  },
];
